// extracted by mini-css-extract-plugin
export var modal = "_hg-0";